import script from "./Home.vue?vue&type=script&setup=true&name=Home&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&name=Home&lang=js"

import "./Home.vue?vue&type=style&index=0&id=27fa4e59&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fa4e59"]])

export default __exports__